module.exports = __webpack_public_path__ + "media/images/flags/lc-c6488de9494a4e151cc47bdfadffdb4d.svg";